import { useState } from 'react';

export default function FAQSection() {
  const faqs = [
    {
      q: 'What exactly is a pandabuyspreadsheet?',
      a: 'A pandabuyspreadsheet is a curated, structured database that organizes product listings — including shoes, clothing, accessories, and more — into a searchable format. Each entry typically includes product photos, seller information, price ranges, and quality ratings, making it far more efficient than browsing individual store pages one by one.',
    },
    {
      q: 'How often are the spreadsheets updated?',
      a: 'Our pandabuyspreadsheet database is updated daily with fresh product entries, new seller information, and updated pricing data. Trending items and seasonal collections receive priority updates to ensure you always have access to the latest inventory. Some high-demand categories are refreshed multiple times per day.',
    },
    {
      q: 'Are the products in the spreadsheet verified?',
      a: 'Yes. Every product listed in our pandabuyspreadsheet goes through community verification. Entries include real QC (quality control) photos submitted by actual buyers, and seller ratings are based on aggregated community feedback. This multi-layer verification process helps ensure you find reliable products.',
    },
    {
      q: 'How do I use the spreadsheet to find specific items?',
      a: 'You can filter spreadsheets by category, price range, seller rating, or update date. For example, if you are looking for sneakers under $60 from highly rated sellers, apply the Shoes category filter, set your price range, and sort by quality score. The results will show only matching entries.',
    },
    {
      q: 'Is there a cost to access the pandabuyspreadsheet?',
      a: 'Access to the basic pandabuyspreadsheet categories is free. You can browse trending items, compare prices, and view seller ratings without any subscription. Premium features including advanced filters, price alerts, and early access to new spreadsheet drops may be available for registered users.',
    },
    {
      q: 'How does pandabuyspreadsheet compare to regular shopping?',
      a: 'Unlike regular online shopping where you browse one store at a time, pandabuyspreadsheet aggregates products from multiple sources into a single, comparable view. You can see side-by-side price comparisons, quality ratings, and buyer feedback — all in one place. This saves hours of research and helps you make more informed purchasing decisions.',
    },
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-700 bg-primary-100 rounded-full mb-3">
            FAQ
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            Frequently Asked Questions About pandabuyspreadsheet
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h4 className="text-sm md:text-base font-heading font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}